import http from '@/utils/http'

export const loadUsers = (params = {}) => http.get('/users', { params })

export const createUser = (body = {}) => http.post('/users', body)

export const deleteUser = (id) => http.delete(`/users/${id}`)

export const viewUser = (id) => http.get(`/users/${id}`)

export const updateUser = (id, body = {}) => http.put(`/users/${id}`, body)

export const loadRoles = (params = {}) => http.get('/roles', { params })

export const createRole = (body = {}) => http.post('/roles', body)

export const deleteRole = (id) => http.delete(`/roles/${id}`)

export const viewRole = (id) => http.get(`/roles/${id}`)

export const updateRole = (id, body = {}) => http.put(`/roles/${id}`, body)

export default {}
